export function applyNestedForms(form, nestedFormsById) {
    var _a;
    if (!form.nestedForms && !nestedFormsById) {
        return form;
    }
    const nestedFormsByTarget = getNestedFormsByTarget(form);
    return Object.assign(Object.assign({}, form), { fields: (_a = form.fields) === null || _a === void 0 ? void 0 : _a.map((field) => {
            var _a;
            const fieldTarget = field.target;
            if (!fieldTarget) {
                return field;
            }
            const nestedFormId = field.nestedFormId;
            if (!nestedFormId) {
                return field;
            }
            const nestedForm = (_a = nestedFormsByTarget === null || nestedFormsByTarget === void 0 ? void 0 : nestedFormsByTarget[fieldTarget]) !== null && _a !== void 0 ? _a : nestedFormsById === null || nestedFormsById === void 0 ? void 0 : nestedFormsById[nestedFormId];
            if (nestedForm) {
                return Object.assign(Object.assign({}, field), { view: Object.assign(Object.assign({}, field.view), { form: nestedForm }) });
            }
            return field;
        }) });
}
export function getNestedFormsByTarget(form) {
    var _a;
    return (_a = form.nestedForms) === null || _a === void 0 ? void 0 : _a.reduce((byTarget, { targets, form: nestedForm }) => {
        if (!nestedForm || !targets) {
            return byTarget;
        }
        for (const target of targets) {
            byTarget[target] = nestedForm;
        }
        return byTarget;
    }, {});
}
export function getNestedFormArray(formsByTarget) {
    return Object.keys(formsByTarget).map((target) => {
        return { targets: [target], form: formsByTarget[target] };
    });
}
//# sourceMappingURL=apply-nested-forms.js.map